const prettifyUrl = (url) =>
  url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split("/")[0];

export default prettifyUrl;
